// Sydney Trains, NSW TrainLink Intercity & Sydney Metro lines.
// Source: Transport for NSW official line designations & colours.
// Colour values approximate the official TfNSW palette.
// `stops` are representative all-stations sequences used for one-click autofill.

export const LINES = [
  // ---- Sydney Trains suburban ----
  {
    code: "T1",
    label: "T1 North Shore & Western",
    color: "#F99D1C",
    textColor: "#000",
    stops: [
      "Central", "Redfern", "Strathfield", "Homebush", "Flemington", "Lidcombe",
      "Auburn", "Clyde", "Granville", "Harris Park", "Parramatta", "Westmead",
      "Wentworthville", "Pendle Hill", "Toongabbie", "Seven Hills", "Blacktown",
      "Doonside", "Rooty Hill", "Mount Druitt", "St Marys", "Werrington",
      "Kingswood", "Penrith", "Emu Plains",
    ],
  },
  {
    code: "T2",
    label: "T2 Inner West & Leppington",
    color: "#0098CD",
    textColor: "#000",
    stops: [
      "Central", "Redfern", "Macdonaldtown", "Newtown", "Stanmore", "Petersham",
      "Lewisham", "Summer Hill", "Ashfield", "Croydon", "Burwood", "Strathfield",
      "Lidcombe", "Berala", "Regents Park", "Sefton", "Chester Hill",
      "Leightonfield", "Villawood", "Carramar", "Cabramatta", "Warwick Farm",
      "Liverpool", "Casula", "Glenfield", "Edmondson Park", "Leppington",
    ],
  },
  {
    code: "T3",
    label: "T3 Bankstown",
    color: "#F37021",
    textColor: "#000",
    stops: [
      "Sydenham", "Marrickville", "Dulwich Hill", "Hurlstone Park", "Canterbury",
      "Campsie", "Belmore", "Lakemba", "Wiley Park", "Punchbowl", "Bankstown",
    ],
  },
  {
    code: "T4",
    label: "T4 Eastern Suburbs & Illawarra",
    color: "#005AA3",
    textColor: "#FFF",
    stops: [
      "Bondi Junction", "Kings Cross", "Edgecliff", "Martin Place", "Town Hall",
      "Central", "Redfern", "Erskineville", "St Peters", "Sydenham", "Tempe",
      "Wolli Creek", "Arncliffe", "Banksia", "Rockdale", "Kogarah", "Carlton",
      "Allawah", "Hurstville", "Penshurst", "Mortdale", "Oatley", "Como",
      "Jannali", "Sutherland", "Loftus", "Engadine", "Heathcote", "Waterfall",
    ],
  },
  {
    code: "T5",
    label: "T5 Cumberland",
    color: "#C4258F",
    textColor: "#FFF",
    stops: [
      "Leppington", "Edmondson Park", "Glenfield", "Casula", "Liverpool",
      "Warwick Farm", "Cabramatta", "Canley Vale", "Fairfield", "Yennora",
      "Guildford", "Merrylands", "Harris Park", "Parramatta", "Westmead",
      "Wentworthville", "Pendle Hill", "Toongabbie", "Seven Hills", "Blacktown",
      "Marayong", "Quakers Hill", "Schofields", "Riverstone", "Vineyard",
      "Mulgrave", "Windsor", "Clarendon", "East Richmond", "Richmond",
    ],
  },
  {
    code: "T6",
    label: "T6 Lidcombe – Bankstown",
    color: "#7D3F22",
    textColor: "#FFF",
    stops: [
      "Lidcombe", "Berala", "Regents Park", "Sefton", "Chester Hill", "Birrong",
      "Yagoona", "Bankstown",
    ],
  },
  {
    code: "T7",
    label: "T7 Olympic Park",
    color: "#6F818E",
    textColor: "#000",
    stops: ["Lidcombe", "Olympic Park"],
  },
  {
    code: "T8",
    label: "T8 Airport & South",
    color: "#00954C",
    textColor: "#FFF",
    stops: [
      "Central", "Museum", "St James", "Circular Quay", "Wynyard", "Town Hall",
      "Green Square", "Mascot", "Domestic Airport", "International Airport",
      "Wolli Creek", "Turrella", "Bardwell Park", "Bexley North", "Kingsgrove",
      "Beverly Hills", "Narwee", "Riverwood", "Padstow", "Revesby", "Panania",
      "East Hills", "Holsworthy", "Glenfield", "Macquarie Fields", "Ingleburn",
      "Minto", "Leumeah", "Campbelltown", "Macarthur",
    ],
  },
  {
    code: "T9",
    label: "T9 Northern",
    color: "#D11F2F",
    textColor: "#FFF",
    stops: [
      "Gordon", "Killara", "Lindfield", "Roseville", "Chatswood", "Artarmon",
      "St Leonards", "Wollstonecraft", "Waverton", "North Sydney",
      "Milsons Point", "Wynyard", "Town Hall", "Central", "Redfern",
      "Macdonaldtown", "Newtown", "Stanmore", "Petersham", "Lewisham",
      "Summer Hill", "Ashfield", "Croydon", "Burwood", "Strathfield",
      "North Strathfield", "Concord West", "Rhodes", "Meadowbank", "West Ryde",
      "Denistone", "Eastwood", "Epping", "Cheltenham", "Beecroft",
      "Pennant Hills", "Thornleigh", "Normanhurst", "Hornsby",
    ],
  },

  // ---- NSW TrainLink Intercity ----
  {
    code: "BMT",
    label: "Blue Mountains Line",
    color: "#F99D1C",
    textColor: "#000",
    stops: [
      "Central", "Strathfield", "Parramatta", "Blacktown", "Penrith",
      "Emu Plains", "Lapstone", "Glenbrook", "Blaxland", "Warrimoo",
      "Valley Heights", "Springwood", "Faulconbridge", "Linden", "Woodford",
      "Hazelbrook", "Lawson", "Bullaburra", "Wentworth Falls", "Leura",
      "Katoomba", "Medlow Bath", "Blackheath", "Mount Victoria", "Lithgow",
    ],
  },
  {
    code: "CCN",
    label: "Central Coast & Newcastle",
    color: "#D11F2F",
    textColor: "#FFF",
    stops: [
      "Central", "Strathfield", "Epping", "Hornsby", "Cowan", "Hawkesbury River",
      "Wondabyne", "Woy Woy", "Koolewong", "Tascott", "Point Clare", "Gosford",
      "Narara", "Niagara Park", "Lisarow", "Ourimbah", "Tuggerah", "Wyong",
      "Warnervale", "Wyee", "Morisset", "Dora Creek", "Awaba", "Fassifern",
      "Booragul", "Teralba", "Cockle Creek", "Cardiff", "Kotara", "Adamstown",
      "Broadmeadow", "Hamilton", "Wickham", "Newcastle Interchange",
    ],
  },
  {
    code: "SCO",
    label: "South Coast Line",
    color: "#005AA3",
    textColor: "#FFF",
    stops: [
      "Central", "Sutherland", "Waterfall", "Helensburgh", "Otford",
      "Stanwell Park", "Coalcliff", "Scarborough", "Wombarra", "Coledale",
      "Austinmer", "Thirroul", "Bulli", "Woonona", "Bellambi", "Corrimal",
      "Towradgi", "Fairy Meadow", "North Wollongong", "Wollongong", "Coniston",
      "Unanderra", "Kembla Grange", "Dapto", "Albion Park", "Oak Flats",
      "Dunmore", "Shellharbour Junction", "Minnamurra", "Bombo", "Kiama",
      "Gerringong", "Berry", "Bomaderry",
    ],
  },
  {
    code: "SHL",
    label: "Southern Highlands Line",
    color: "#00954C",
    textColor: "#FFF",
    stops: [
      "Campbelltown", "Macarthur", "Menangle Park", "Menangle", "Douglas Park",
      "Picton", "Tahmoor", "Bargo", "Yerrinbool", "Mittagong", "Bowral",
      "Burradoo", "Moss Vale", "Exeter", "Bundanoon", "Wingello", "Penrose",
      "Tallong", "Goulburn",
    ],
  },
  {
    code: "HUN",
    label: "Hunter Line",
    color: "#833134",
    textColor: "#FFF",
    stops: [
      "Newcastle Interchange", "Hamilton", "Broadmeadow", "Sandgate", "Hexham",
      "Tarro", "Beresfield", "Thornton", "Metford", "East Maitland", "Victoria Street",
      "High Street", "Maitland", "Telarah", "Farley", "Allandale", "Lochinvar",
      "Greta", "Branxton", "Singleton", "Muswellbrook", "Scone",
    ],
  },

  // ---- NSW TrainLink Regional (XPT / Xplorer / Endeavour) ----
  {
    code: "NCX",
    label: "North Coast XPT · Sydney – Grafton – Casino – Brisbane",
    color: "#732982",
    textColor: "#FFF",
    bookingRequired: true,
    stops: [
      "Central", "Strathfield", "Hornsby", "Broadmeadow", "Maitland", "Dungog",
      "Gloucester", "Wingham", "Taree", "Wauchope", "Kempsey", "Macksville",
      "Nambucca Heads", "Urunga", "Sawtell", "Coffs Harbour", "Grafton",
      "Casino", "Kyogle", "Border Loop", "Beaudesert", "Salisbury",
      "South Brisbane", "Roma Street",
    ],
  },
  {
    code: "NRX",
    label: "Northern XPT · Sydney – Armidale / Moree",
    color: "#732982",
    textColor: "#FFF",
    bookingRequired: true,
    stops: [
      "Central", "Strathfield", "Broadmeadow", "Maitland", "Muswellbrook",
      "Scone", "Werris Creek", "Tamworth", "Uralla", "Armidale",
      "(alt.) Gunnedah", "Narrabri", "Moree",
    ],
  },
  {
    code: "WSX",
    label: "Western · Sydney – Dubbo / Broken Hill",
    color: "#732982",
    textColor: "#FFF",
    bookingRequired: true,
    stops: [
      "Central", "Strathfield", "Parramatta", "Blacktown", "Penrith",
      "Katoomba", "Lithgow", "Bathurst", "Blayney", "Orange", "Wellington",
      "Dubbo", "Parkes", "Condobolin", "Ivanhoe", "Menindee", "Broken Hill",
    ],
  },
  {
    code: "STX",
    label: "Southern XPT · Sydney – Melbourne / Griffith",
    color: "#732982",
    textColor: "#FFF",
    bookingRequired: true,
    stops: [
      "Central", "Strathfield", "Campbelltown", "Moss Vale", "Goulburn",
      "Yass Junction", "Cootamundra", "Junee", "Wagga Wagga", "The Rock",
      "Henty", "Culcairn", "Albury", "Wodonga", "Benalla", "Seymour",
      "Melbourne Southern Cross",
    ],
  },
  {
    code: "GRF",
    label: "Griffith Xplorer · via Wagga",
    color: "#732982",
    textColor: "#FFF",
    bookingRequired: true,
    stops: [
      "Central", "Strathfield", "Campbelltown", "Moss Vale", "Goulburn",
      "Yass Junction", "Harden", "Cootamundra", "Junee", "Wagga Wagga",
      "Coolamon", "Ganmain", "Matong", "Grong Grong", "Narrandera",
      "Yanco", "Leeton", "Griffith",
    ],
  },
  {
    code: "CBR",
    label: "Canberra Xplorer",
    color: "#732982",
    textColor: "#FFF",
    bookingRequired: true,
    stops: [
      "Central", "Strathfield", "Campbelltown", "Mittagong", "Bowral",
      "Moss Vale", "Goulburn", "Tarago", "Bungendore", "Queanbeyan",
      "Canberra",
    ],
  },
  {
    code: "END",
    label: "Endeavour · Sydney – Nowra / Kiama / Goulburn",
    color: "#732982",
    textColor: "#FFF",
    bookingRequired: true,
    stops: [
      "Central", "Sydenham", "Wolli Creek", "Hurstville", "Sutherland",
      "Waterfall", "Helensburgh", "Thirroul", "Wollongong", "Dapto",
      "Oak Flats", "Kiama", "Berry", "Bomaderry",
    ],
  },

  // ---- Sydney Metro ----
  {
    code: "M",
    label: "M · Sydney Metro",
    color: "#0098CD",
    textColor: "#FFF",
    stops: [
      "Tallawong", "Rouse Hill", "Kellyville", "Bella Vista", "Norwest",
      "Hills Showground", "Castle Hill", "Cherrybrook", "Epping",
      "Macquarie University", "Macquarie Park", "North Ryde", "Chatswood",
      "Crows Nest", "Victoria Cross", "Barangaroo", "Martin Place", "Gadigal",
      "Central", "Waterloo", "Sydenham",
    ],
  },
];

export const LINE_BY_CODE = Object.fromEntries(LINES.map((l) => [l.code, l]));

export function getLine(code) {
  return LINE_BY_CODE[code] || LINES[0];
}
